import React, { useEffect, useState } from "react";

//css
import "bootstrap/dist/css/bootstrap.min.css";
import { Col, Container, Row, Card, Button } from "react-bootstrap";
import "../css/style.css";

//ant design
import "antd/dist/antd.css";
import { CalendarFilled, ClockCircleFilled } from "@ant-design/icons";

//jquery
import $ from "jquery";

//date picker
import PickyDateTime from "react-picky-date-time";
import Timekeeper from "react-timekeeper";

//navbar 
import Navbar from "./NavBar"
import { db } from "../firebase/firebase";
import { alert } from "../util/toast";

//dayjs
import dayjs from "dayjs"

const UpdateAvalilability = () => {
  var dateObj = new Date();

  let now = dayjs()

  const userId = localStorage.getItem("id");

  const [time, setTime] = useState([]);
  // const [timeError, setTimeError] = useState("")

  const [errors, setError] = useState({
    time: "",
    date: ""
  })

  const [date, setDate] = useState({
    year: dateObj.getUTCMonth(),
    month: dateObj.getUTCDate(),
    date: dateObj.getUTCFullYear(),
  });

  const onYearPicked = (res) => {
    let { year } = res;
    setDate({ year: year });
  };

  const onMonthPicked = (res) => {
    let { month, year } = res;
    setDate({ year: year, month: month });
  };

  const onDatePicked = (res) => {
    let { date, month, year } = res;
    setDate({ year: year, month: month, date: date });
  };

  const onResetDate = (res) => {
    let { date, month, year } = res;
    setDate({ year: year, month: month, date: date });
  };

  const onResetDefaultDate = (res) => {
    let { date, month, year } = res;
    setDate({ year: year, month: month, date: date });
  };

  const handleSelectTime = (id) => {
    // debugger;
    $(`#${id}`).toggleClass("timePickerActive");
    const selectedTime = $(`#${id}`).hasClass("timePickerActive");
    if (selectedTime) {
      time.push(id)
    } else {
      let index = time.indexOf(id);
      if (index != -1) {
        time.splice(index, 1); // remove 1 element from index 
      }
    }
  };

  const handleSubmit = async () => {
    if (now.diff(new Date(date.year + "-" + date.month + "-" + date.date), "days") > 0) {
      return setError({ ...errors, date: "You can't select previos date!" })
    }
    if (time.length == 0) {
      return setError({ ...errors, time: "Please select one time slot!" })
    }
    const query = await db
      .collection("interviewer")
      .where("userId", "==", parseInt(userId))
      .get();

    if (query.docs.length === 0) {

      await db.collection("interviewer").add({
        userId: parseInt(userId),
        date: new Date(date.year + "-" + date.month + "-" + date.date),
        time: time,
      });
    }
    if (query.docs.length === 1) {
      const data = {
        date: new Date(date.year + "-" + date.month + "-" + date.date),
        time: time,
      }
      const interviwerFirebaseId = query.docs[0].id;
      await db.doc(`/interviewer/${interviwerFirebaseId}`).update(data);
    }

    alert("success", "Your avaiability updated successfully!");
  }


  return (
    <>
      <Navbar />
      <div className="bgColor">
        <Container fluid="sm">
          <Row className="py-5">
            <Col className="py-3 ">
              <Card
                className="mx-auto"
                style={{
                  borderRadius: 15,
                  borderColor: "#3F8AF7",
                }}
              >
                <Card.Title className="p-3 font-weight-bold ">
                  <Col
                    md={12}
                    className="py-3 text-center"
                    style={{ fontSize: 28, color: "#2E8CFF" }}
                  >
                    Update Your Avalability
                  </Col>
                </Card.Title>
                <Card.Body className="m-md-5 m-0 border-top ">
                  <Row className="m-auto py-4 ">
                    <Col sm={12} md={6} className="overflow-auto">
                      <label className="font-weight-bold ml-md-5 pl-md-2 ml-0 pl-0">
                        When
                      </label>

                      <div className="text-center pb-5">
                        <div
                          className="input-group mx-auto"
                          style={{ width: "73%" }}
                        >
                          <input
                            className="form-control border-right-0"
                            value={`${date.date}/${date.month}/${date.year}`}
                            onClick={() =>
                              setDate({
                                date: dateObj.getUTCFullYear(),
                                month: dateObj.getUTCDate(),
                                year: dateObj.getUTCMonth(),
                              })
                            }
                          />
                          <span className="input-group-append bg-white border-left-0">
                            <span className="input-group-text bg-transparent">
                              <CalendarFilled />
                            </span>
                          </span>
                        </div>
                        {errors.date && (
                          <div class="text-center">
                            <p className="text-danger">{errors.date}</p>
                          </div>
                        )}
                      </div>
                    </Col>
                    <Col sm={12} md={6} className="overflow-auto pb-5">
                      <PickyDateTime
                        size="m"
                        mode={0}
                        show={true}
                        locale="en-us"
                        defaultDate={`${date.date}/${date.month}/${date.year}`}
                        onYearPicked={(res) => onYearPicked(res)}
                        onMonthPicked={(res) => onMonthPicked(res)}
                        onDatePicked={(res) => onDatePicked(res)}
                        onResetDate={(res) => onResetDate(res)}
                        onResetDefaultDate={(res) => onResetDefaultDate(res)}
                      />

                    </Col>
                  </Row>
                  <label className="font-weight-bold ml-md-5 pl-md-2 ml-0 pl-0  pt-5">
                    Select Time
                  </label>
                  <Row className="ml-md-5 pl-md-2 ml-0 pl-0">
                    <div className="timePicker mx-2 mx-md-5">
                      <Row className="horizontalWrap">
                        <Col
                          id="00"
                          onClick={() => handleSelectTime("00")}
                          className="borerRight"
                        >
                          00:00
                        </Col>
                        <Col
                          className="borerRight"
                          id="01"
                          onClick={() => handleSelectTime("01")}
                        >
                          01:00
                        </Col>
                        <Col
                          className="borerRight"
                          id="02"
                          onClick={() => handleSelectTime("02")}
                        >
                          02:00
                        </Col>
                        <Col
                          className="borerRight"
                          id="03"
                          onClick={() => handleSelectTime("03")}
                        >
                          03:00
                        </Col>
                        <Col
                          className="borerRight"
                          id="04"
                          onClick={() => handleSelectTime("04")}
                        >
                          04:00
                        </Col>
                        <Col
                          className="borerRight"
                          id="05"
                          onClick={() => handleSelectTime("05")}
                        >
                          05:00
                        </Col>
                        <Col
                          className="borerRight"
                          id="06"
                          onClick={() => handleSelectTime("06")}
                        >
                          06:00
                        </Col>
                        <Col
                          className="borerRight"
                          id="07"
                          onClick={() => handleSelectTime("07")}
                        >
                          07:00
                        </Col>
                        <Col
                          className="borerRight"
                          id="08"
                          onClick={() => handleSelectTime("08")}
                        >
                          08:00
                        </Col>
                        <Col
                          className="borerRight"
                          id="09"
                          onClick={() => handleSelectTime("09")}
                        >
                          09:00
                        </Col>
                      </Row>
                    </div>

                    <div className="timePicker mt-3 mx-2 mx-md-5">
                      <Row className="horizontalWrap">
                        <Col
                          className="borerRight"
                          id="10"
                          onClick={() => handleSelectTime("10")}
                        >
                          10:00
                        </Col>
                        <Col
                          className="borerRight"
                          id="11"
                          onClick={() => handleSelectTime("11")}
                        >
                          11:00
                        </Col>
                        <Col
                          className="borerRight"
                          id="12"
                          onClick={() => handleSelectTime("12")}
                        >
                          12:00
                        </Col>
                        <Col
                          className="borerRight"
                          id="13"
                          onClick={() => handleSelectTime("13")}
                        >
                          13:00
                        </Col>
                        <Col
                          className="borerRight"
                          id="14"
                          onClick={() => handleSelectTime("14")}
                        >
                          14:00
                        </Col>
                        <Col
                          className="borerRight"
                          id="15"
                          onClick={() => handleSelectTime("15")}
                        >
                          15:00
                        </Col>
                        <Col
                          className="borerRight"
                          id="16"
                          onClick={() => handleSelectTime("16")}
                        >
                          16:00
                        </Col>
                        <Col
                          className="borerRight"
                          id="17"
                          onClick={() => handleSelectTime("17")}
                        >
                          17:00
                        </Col>
                        <Col
                          className="borerRight"
                          id="18"
                          onClick={() => handleSelectTime("18")}
                        >
                          18:00
                        </Col>
                        <Col
                          className="borerRight"
                          id="19"
                          onClick={() => handleSelectTime("19")}
                        >
                          19:00
                        </Col>
                      </Row>
                    </div>
                    <div className="timePicker mt-3 mx-2 mx-md-5">
                      <Row className="horizontalWrap">
                        <Col
                          className="borerRight"
                          id="20"
                          onClick={() => handleSelectTime("20")}
                        >
                          20:00
                        </Col>
                        <Col
                          className="borerRight"
                          id="21"
                          onClick={() => handleSelectTime("21")}
                        >
                          21:00
                        </Col>
                        <Col
                          className="borerRight"
                          id="22"
                          onClick={() => handleSelectTime("22")}
                        >
                          22:00
                        </Col>
                        <Col
                          className="borerRight"
                          id="23"
                          onClick={() => handleSelectTime("23")}
                        >
                          23:00
                        </Col>
                      </Row>
                    </div>
                  </Row>
                  <Row>
                    {errors.time && (
                      <div class="ml-3 mt-2 text-center">
                        <p className="text-danger text-center pl-5 ml-5">{errors.time}</p>
                      </div>
                    )}
                  </Row>
                  <div className="m-auto text-center pt-2 ">
                    <Button
                      type="primary"
                      htmlType="submit"
                      className="mt-3 shadow-lg btn"
                      style={{ height: 60, fontSize: 20, fontWeight: "bold" }}
                      onClick={handleSubmit}
                    >
                      Update Availability
                    </Button>
                  </div>
                </Card.Body>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </>
  );
};

export default UpdateAvalilability;
